import { DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";

const DietPlanHeader = ({ headerData, onChange }) => {
  return (
    <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4">
      <h3 className="font-semibold text-emerald-800 mb-4 flex items-center gap-2">
        <span className="w-2 h-4 bg-emerald-500 rounded-full"></span>
        Diet Plan Details
      </h3>

      <div className="flex flex-wrap gap-4">
        <div className="flex flex-col gap-1 min-w-[200px] flex-1">
          <label className="text-xs font-semibold text-gray-600">
            Diet Chart Title
          </label>
          <input
            className="border rounded-lg px-3 py-2 text-xs outline-none focus:border-brand-primaryColor bg-white"
            placeholder="e.g. Weight Loss Plan"
            value={headerData.chartTitle}
            onChange={(e) => onChange("chartTitle", e.target.value)}
          />
        </div>

        <div className="flex flex-col gap-1 w-32">
          <label className="text-xs font-semibold text-gray-600">
            Number of Days
          </label>
          <input
            type="number"
            min="1"
            max="30"
            className="border rounded-lg px-3 py-2 text-xs outline-none focus:border-brand-primaryColor bg-white"
            placeholder="Enter days"
            value={headerData.noOfDays}
            onChange={(e) => onChange("noOfDays", parseInt(e.target.value) || 0)}
          />
        </div>
      </div>
    </div>
  );
};

export default DietPlanHeader;
